<template>
  <div class="p-7 max-w-xl mx-auto h-full flex flex-col justify-between">
    <div>
      <ion-row>
        <ion-col class="text-center">
          <ion-icon
            src="/assets/general/maintenance.svg"
            class="w-[130px] h-[130px] fadein-400 my-12"
          ></ion-icon>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="text-center">
          <h2 class="text-[24px] font-bold pb-6 text-white">
            We'll be right back!
          </h2>
          <p class="text-sm text-white pb-3">
            This service is temporarily down for a bit of maintenance
          </p>
        </ion-col>
      </ion-row>
    </div>
    <div>
      <ion-row>
        <ion-col class="text-center">
          <button
            class="button-white button-shadow px-6 flex justify-center items-center mt-6"
            @click="tryAgain"
          >
            <span class="block text-sm ion-text-primary font-bold">Try Again</span>
          </button>
        </ion-col>
      </ion-row>
    </div>
  </div>
</template>
<script setup>
import router from "@/router";
const tryAgain = () => {
  router.go();
};
</script>
